import Service from 'src/service.js';

export default class AuthModel{
    postAuthData(login, pass){
        Service.postAuth(login, pass);
    }
}


// WEBPACK FOOTER //
// ./src/Auth/AuthModel.js